export const errorsCs = {
  'Connect LinkedIn before syncing posts': 'Před synchronizací příspěvků nejprve připojte LinkedIn.',
  'Email already registered': 'Tento e-mail je již zaregistrován.',
  'Invalid credentials': 'Neplatný e-mail nebo heslo.',
  'Not authenticated': 'Nejste přihlášeni.',
  'Insufficient permissions': 'K této akci nemáte oprávnění.',
  'Admin access required': 'Je vyžadován přístup administrátora.',
  'User not found': 'Uživatel nebyl nalezen.',
  'Token expired': 'Platnost odkazu nebo relace vypršela.',
  'Invalid token': 'Neplatný token.',
  'Invalid or expired token': 'Neplatný nebo expirovaný odkaz.',
  'Invalid 2FA code': 'Neplatný kód 2FA.',
  '2FA challenge expired': 'Platnost ověření 2FA vypršela.',
  'Current password is incorrect': 'Současné heslo není správné.',
  'Knowledge source not found': 'Zdroj znalostí nebyl nalezen.',
  'Conversation not found': 'Konverzace nebyla nalezena.',
  'Task not found': 'Úkol nebyl nalezen.',
  'Approval not found': 'Schválení nebylo nalezeno.',
  'Approval already decided': 'O tomto schválení již bylo rozhodnuto.',
  'No LinkedIn account': 'Není připojen LinkedIn účet.',
  'Failed to send via LinkedIn': 'Odeslání přes LinkedIn se nezdařilo.',
  'Google Calendar reconnect required': 'Je nutné znovu připojit Google Kalendář.',
  'Google Calendar OAuth is not configured': 'Připojení Google Kalendáře není nakonfigurováno.',
  'Google Calendar is not connected': 'Google Kalendář není připojen.',
  'Selected calendar is not writable or not available': 'Vybraný kalendář není dostupný nebo do něj nelze zapisovat.',
  'Booking end must be after start': 'Konec rezervace musí být po jejím začátku.',
  'Booking not found': 'Rezervace nebyla nalezena.',
  'Cancelled bookings cannot be rescheduled': 'Zrušené rezervace nelze přeplánovat.',
  'LinkedIn integration not configured': 'Integrace LinkedIn není nakonfigurována.',
  'LinkedIn connection expired. Reconnect LinkedIn in Settings before syncing.': 'Připojení LinkedIn vypršelo. Před synchronizací znovu připojte LinkedIn v Nastavení.',
  'No OpenAI key configured': 'Není nastaven klíč OpenAI.',
  'No OpenAI key configured. Add one in Settings.': 'Není nastaven klíč OpenAI. Přidejte jej v nastavení.',
  'AI Auto-Reply is not enabled': 'Automatické odpovědi AI nejsou zapnuté.',
  'File too large (max 25MB)': 'Soubor je příliš velký (maximum je 25 MB).',
  'Could not load data.': 'Data se nepodařilo načíst.',
  'Could not save changes.': 'Změny se nepodařilo uložit.',
  'An unexpected error occurred.': 'Došlo k neočekávané chybě.',
};
